import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './Css/TrendingVideos.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Mousewheel, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import KidStoryCard from '../../pages/video-pages/KidStoryCard';
import { usePopularVideos } from '../../hooks/useVideosHooks';

const TrendingVideos = () => {
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const { videos, isLoading, error } = usePopularVideos(1, 10);

  return (
    <section className={styles.trendingSection}>
      <div className={styles.trendingHeader}>
        <h1 className={styles.title}>Videos</h1>
        <div className={styles.navigationButtons}>
          <button ref={navigationPrevRef} className={styles.navButton} aria-label="Previous">
            <ChevronLeft size={24} />
          </button>
          <button ref={navigationNextRef} className={styles.navButton} aria-label="Next">
            <ChevronRight size={24} />
          </button>
        </div>
      </div>
      <div className={styles.swiperContainer}>
        <Swiper
          freeMode={{
            enabled: true,
            momentum: true,
            momentumRatio: 0.8,
            momentumVelocityRatio: 0.8,
            minimumVelocity: 0.02,
          }}
          modules={[Navigation, Mousewheel, FreeMode]}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1.5,
            releaseOnEdges: true,
          }}
          speed={600}
          resistance={false}
          resistanceRatio={0}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          breakpoints={{
            320: { slidesPerView: 1.8, spaceBetween: 10 },
            480: { slidesPerView: 2, spaceBetween: 15 },
            768: { slidesPerView: 2, spaceBetween: 20 },
            1024: { slidesPerView: 4, spaceBetween: 20 },
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
          className={styles.swiperWrapper}
        >
          {isLoading ? (
            <p>Loading...</p>
          ) : error ? (
            <p>Error loading videos.</p>
          ) : (
            videos.map((item) => (
              <SwiperSlide key={item.id} className={styles.swiperSlide}>
                <KidStoryCard story={item} />
              </SwiperSlide>
            ))
          )}
        </Swiper>
      </div>
    </section>
  );
};

export default TrendingVideos;
